import { useState } from "react";
import { Menu } from "antd";
import classNames from "classnames";

import { ROUTES_SCHEME } from "@/app/routing/route-scheme";
import { LayerType } from "@/app/routing/types";
import { Logo } from "@/app/template/logo";
import { useFindWidth } from "@/shared/hooks/use-find-width";

import { AntMenuItemType } from "../../types";
import { getSubmenuKeys } from "../../utils";
import { BackLayerButton } from "../back-layer-button";

import s from "./menu-styles.module.scss";

const CLOSED_MENU_WIDTH = "80px";
const OPENED_MENU_WIDTH = "280px";
const ASIDE_WIDTH_CLASSNAME = `w-[${CLOSED_MENU_WIDTH}] min-w-[${CLOSED_MENU_WIDTH}]`;
const STICKY_BLOCK_CLASSNAME =
	"sticky left-0 right-0 z-10 bg-ant-color-bg-container border-r border-ant-color-split";

const LARGE_SCREEN_WIDTH = 1640;

const SUBMENU_KEYS = getSubmenuKeys(ROUTES_SCHEME);

export const NavigationMenu = ({
	menuItems,
	activeMenuItemKey,
	layer,
	isMobile,
}: {
	menuItems: AntMenuItemType[];
	activeMenuItemKey: string;
	layer: LayerType;
	isMobile?: boolean;
}) => {
	const [isHoverMenu, setIsHoverMenu] = useState(false);

	const isLargeScreen = !useFindWidth(LARGE_SCREEN_WIDTH);
	const isOpenMenu = isHoverMenu || isLargeScreen || isMobile;

	return (
		<aside
			data-testid="aside"
			onMouseEnter={() => setIsHoverMenu(true)}
			onMouseLeave={() => setIsHoverMenu(false)}
			className={classNames(s.aside, { [ASIDE_WIDTH_CLASSNAME]: !isLargeScreen })}
		>
			<div
				className="flex flex-col h-full"
				style={{
					width: isOpenMenu ? OPENED_MENU_WIDTH : CLOSED_MENU_WIDTH,
					minWidth: !isOpenMenu ? CLOSED_MENU_WIDTH : undefined,
					// Ensure menu overlaps selects when open, but stays below modals when closed
					zIndex: isOpenMenu ? 9999 : 999,
					position: !isLargeScreen ? "absolute" : undefined,

					transition: "width 0.3s ease-in-out",
				}}
			>
				{!isMobile && (
					<div className={classNames(STICKY_BLOCK_CLASSNAME, "top-0 p-20")}>
						<Logo isOpenMenu={isOpenMenu} />
					</div>
				)}

				<Menu
					inlineCollapsed={!isOpenMenu}
					items={menuItems}
					selectedKeys={activeMenuItemKey ? [activeMenuItemKey] : undefined}
					mode="inline"
					defaultOpenKeys={SUBMENU_KEYS}
					className="w-full flex-1 overflow-y-auto bg-ant-color-bg-container"
				/>

				<div className={classNames(STICKY_BLOCK_CLASSNAME, "bottom-0")}>
					<BackLayerButton isOpenMenu={isOpenMenu} layer={layer} />
				</div>
			</div>
		</aside>
	);
};
